// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__128HH","title":"styles_title__2cvhI","cardWrapper":"styles_cardWrapper__15Ccs"};